


































































































import { TableHeader } from '@/utils/interfaces'
import { AsYouType } from 'libphonenumber-js'
import ActionButton from '@/components/ActionButton.vue'
import { tableHandler } from '@/utils/mixins/tableHandler'
import { GetTopUpDTO, TopUpAgent } from '@/utils/interfaces/topup.interface'
import { chipClasses } from '@/utils/chipClasses.constant'
import TopUpDetails from '@/components/Services/TopUps/TopUpDetails.vue'
import TitleButton from '@/components/TitleButton.vue'
import HistoryDialog from '@/components/Services/TopUps/HistoryDialog.vue'
import { formatDate } from '@/utils/functions'
import mixins from 'vue-typed-mixins'
import { reportMixin } from '@/utils/mixins/reportMixin'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import TreeviewButton from '@/components/Services/TopUps/TreeviewButton.vue'
import SmsFilter from '@/components/Services/Sms/SmsFilter.vue'
import { getSms } from '@/api/Sms/sms.api'
import FlatCard from '~/components/FlatCard.vue'
import TextButton from '~/components/TextButton.vue'
import FlatTable from '~/components/FlatTable.vue'

export default mixins(reportMixin, tableHandler<GetTopUpDTO>()).extend({
  components: {
    appSmsFilter: SmsFilter,
    appActionButton: ActionButton,
    appTopUpDetails: TopUpDetails,
    appTitleButton: TitleButton,
    appHistoryDialog: HistoryDialog,
    appConfirmDialog: ConfirmDialog,
    appTreeviewButton: TreeviewButton,
    FlatCard,
    TextButton,
    FlatTable,
  },
  data() {
    return {
      createDialogModel: false,
      historyDialog: false,
      key: 0,
      headers: [
        {
          text: this.$t('details'),
          value: 'details',
        },
        {
          text: this.$t('number'),
          value: 'destination_account',
        },
        {
          text: this.$t('agent'),
          value: 'from_agent_name',
        },
        {
          text: this.$t('created-at'),
          value: 'created_at',
        },
        {
          text: this.$t('status'),
          value: 'status',
        },
      ] as TableHeader[],
      getter: getSms,
      chipClasses: chipClasses,
      historyItem: null as null | GetTopUpDTO,
      reviewItem: null as null | GetTopUpDTO,
      loadingReport: false,
      confirmDialog: false,
      loadingConfirm: false,
      loadingRefresh: false,
      loadingAgent: false,
      agent: {} as TopUpAgent,
      action: '',
    }
  },
  methods: {
    async getReport() {
      try {
        this.loadingReport = true
        await this.generateReport(this.table.lastFilter)
      } finally {
        this.loadingReport = false
      }
    },
    formatDate(date: string): string {
      return formatDate(date)
    },
    asYouType(value: string) {
      return new AsYouType().input(value)
    },
    async refresh() {
      try {
        this.loadingRefresh = true
        await this.newFilter(this.table.lastFilter)
      } finally {
        this.loadingRefresh = false
      }
    },
    onHistory(item: GetTopUpDTO) {
      this.historyItem = item
      this.historyDialog = true
    },
  },
  created() {
    if (this.$store.getters.profile.role === 'ADMIN') {
      this.headers.splice(3, 0, {
        text: this.$t('provider'),
        value: 'provider',
      })
    }
    if (this.$store.getters.profile.is_superuser) {
      this.headers.splice(2, 1, {
        text: this.$t('created_by'),
        value: 'created_by_name',
      })
    }
  },
})
